/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { finalize, Subject, takeUntil, takeWhile, tap, timer } from 'rxjs';
import { ConfirmationWithCountdownConfig } from './confirm-with-countdown-dialog.types';
import { I18nPluralPipe, NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'confirmation-with-countdown-dialog',
    templateUrl: './confirm-with-countdown-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .confirmation-with-countdown-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    standalone: true,
    imports: [MatButton, I18nPluralPipe, NgClass, MatIcon, MatDialogClose],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class ConfirmationWithCountdownDialogComponent implements OnInit, OnDestroy {

    countdown: number;
    countdownMapping: any = {
        '=1'   : '# ' + this.transloco.translate('second').toLowerCase(),
        'other': '# ' + this.transloco.translate('seconds').toLowerCase()
    };

    private unsubscribe = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationWithCountdownConfig,
        public matDialogRef: MatDialogRef<ConfirmationWithCountdownDialogComponent>,
        private transloco: TranslocoService
    ) { }

    ngOnInit() {
        this.countdown = this.data.seconds;
        timer(1000, 1000)
            .pipe(
                finalize(() => {
                    if (!this.unsubscribe.closed) {
                        this.matDialogRef.close('confirmed');
                    }
                }),
                takeWhile(() => this.countdown > 0),
                takeUntil(this.unsubscribe),
                tap(() => this.countdown--)
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.unsubscribe.complete();
    }
}
